import { FaShare } from "react-icons/fa";
import useSbConfig from "../../Shared/useSbConfig";
import ActionButton from "../../Shared/ActionButton";

export default ({
  shipment
}) => {
  const {
    id,
    order_id
  } = shipment

  const sbConfig = useSbConfig()

  const viewShipment = () => {
    // 1.0 ${sbConfig.merchantUrl}/App/Merchant/#/Orders/${id}/
    // 2.0 ${sbConfig.merchantUrl}/App/Merchant/#/order-shipment-management/orders/${order_id}/shipments/${id}
    window.open(`${sbConfig.merchantUrl}/App/Merchant/#/order-shipment-management/orders/${order_id}/shipments/${id}`)
  }

  return (
    <ActionButton onClick={viewShipment}>
      <FaShare style={{ paddingRight: '10px' }} />
      View
    </ActionButton>
  )
}